<template>
    <section>
        <div class="role">
            <div class="roleRight">
                <div class="roleRight_Top" style="display: block">
                    <template v-if="searchShow">
                        <el-input
                                clearable
                                v-model="search.searchKey"
                                clas="input_search"
                                placeholder="搜索订单号"
                                @keyup.enter.native="getserviceList"
                                style="margin-right: 10px"
                        ></el-input>
                        <el-button size="medium" type="primary" @click="getserviceList(1)"
                        >查询
                        </el-button
                        >
                    </template>
                </div>
                <div class="roleRight_Container public-table-data">
                    <el-table
                            :data="tableData"
                            size="medium"
                            border
                            style="width: 100%"
                            row-key="customerServiceId"
                            v-loading="loading"
                    >
                        <el-table-column fixed label="序号" type="index" width="100">
                        </el-table-column>
                        <el-table-column prop="bizTypeName" label="类型" min-width="120">
                        </el-table-column>
                        <el-table-column prop="name" label="订单名称" min-width="260"></el-table-column>
                        <el-table-column prop="orderNumber" label="订单号" min-width="200">
                        </el-table-column>

                        <el-table-column prop="orderMoney" label="订单金额" min-width="100">
                            <template slot-scope="scope">
                                ￥{{ scope.row.orderMoney }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="payMoney" label="支付金额" min-width="100">
                            <template slot-scope="scope">
                                ￥{{ scope.row.payMoney }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="payStatusName" label="支付状态">
                        </el-table-column>
                        <el-table-column prop="paymentTypeName" label="来源">
                            <template slot-scope="scope">
                              <span v-if="scope.row.newChannelOrder==1">一转</span>
                              <span v-if="scope.row.newChannelOrder==2">二转</span>
                            </template>
                        </el-table-column>
                      <el-table-column prop="appName" label="下单应用" min-width="200">
                      </el-table-column>
                      <el-table-column prop="orderNumber" label="下单渠道" min-width="200">
                        <template slot-scope="scope">
                            <span>{{scope.row.channelName}}({{scope.row.channelCode}})</span>
                        </template>
                      </el-table-column>
                        <el-table-column prop="ctime" label="下单时间" min-width="160"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <div class="button_code">
                                    <el-button
                                            v-if="detailShow"
                                            @click="getOrderDetail(scope.row)"
                                            size="small"
                                    >详情
                                    </el-button
                                    >
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                tableData: [], //顶顶那列表
                loading: false,
                search: {
                    searchKey: ''
                },
                searchShow: false,
                downShow: false,
                detailShow: false,
                qrcodeShow: false,

            };
        },
        mounted() {
            // this.getserviceList();
            this.getPermissionButtonList()
        },
        watch: {},
        methods: {
            getPermissionButtonList() {
                let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
                let arr = JSON.parse(PermissionButtonList)
                if (arr.length) {
                    arr.map(item => {
                        if (item.code == 'kefu:order:query') {
                            this.searchShow = true
                        }
                        if (item.code == "kefu:order:detail") {
                            this.detailShow = true
                        }

                    })
                }
            },
            //订单列表
            async getserviceList(e) {
                this.loading = true;
                const {data: res} = await this.$get(
                    `/kefu/order/list?searchKey=` + this.search.searchKey,
                    {
                        headers: {
                            isLoading: true,
                        },
                    }
                );
                this.loading = false;
                let list = res.data
                if (list) {
                    list.forEach((item) => {
                        item.orderMoney = item.orderMoney / 100
                        item.payMoney = item.payMoney / 100
                    })
                }
                this.tableData = list;
            },
            //订单详情
            getOrderDetail(row) {
                if (row.bizType == 'vip') {
                    this.$router.push({
                        name: 'ORDER_DETAIL',
                        query: {
                            id: 1,
                            title: '会员订单',
                            key: 'orderNumber',
                            value: JSON.stringify(row.orderNumber),
                            path: '/vip/order/info',
                        }
                    })
                } else if (row.bizType == 'exam') {
                    this.$router.push({
                        name: 'ORDER_DETAIL',
                        query: {
                            id: 0,
                            title: '测评订单',
                            key: 'orderNumber',
                            value: JSON.stringify(row.orderNumber),
                            path: '/exam/order/info',
                        }
                    })
                } else if (row.bizType == 'pay') {
                    this.$router.push({
                        name: 'ORDER_DETAIL',
                        query: {
                            id: 2,
                            title: '支付订单',
                            key: 'payCode',
                            value: JSON.stringify(row.orderNumber),
                            path: '/pay/order/info',
                        }
                    })
                } else if (row.bizType == 'znqm' || row.bizType == 'zncm' || row.bizType == 'znys' || row.bizType == 'zwds' || row.bizType == 'znhp') {
                    this.$router.push({
                        name: 'ORDER_DETAIL',
                        query: {
                            id: 4,
                            title: '国学订单',
                            key: 'orderNumber',
                            orderKey: 'bizType',
                            value: JSON.stringify(row.orderNumber),
                            Typevalue: JSON.stringify(row.bizType),
                            path: '/guoxue/order/info',
                        }
                    })
                } else if (row.bizType == 'zncm') {

                } else if (row.bizType == 'gsqm') {

                } else if (row.bizType == 'taluo') {
                    this.$router.push({
                        name: 'ORDER_DETAIL',
                        query: {
                            id: 5,
                            title: '塔罗订单',
                            key: 'orderNumber',
                            value: JSON.stringify(row.orderNumber),
                            path: '/tarot/order/info',
                        }
                    })
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .role {
        display: flex;
        gap: 20px;
        color: #666; /** 公共的黑色 --暂定 */
        font-size: 14px;

        &Right {
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow-x: hidden;

            &_Top {
                display: flex;
                gap: 15px;

                .el-input {
                    width: auto;
                }

                .timeblock {
                    display: flex;
                    box-sizing: border-box;
                    background: #fff;
                    border: 1px solid #dcdfe6;
                    border-radius: 5px;

                    .cla ::v-deep .el-input--suffix .el-input__inner {
                        padding-right: 0;
                    }

                    ::v-deep .el-input__inner {
                        border: none !important;
                        height: 38px;
                    }
                }
            }

            &_Container {
                margin-top: 20px;
            }

            &_pagenation {
                margin: 40px auto;
            }

            ::v-deep .el-table th,
            ::v-deep .el-table td {
                text-align: center !important;
            }
        }
    }

    .el-select {
        margin-bottom: 10px;
        margin-right: 10px;
    }

    .name-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        margin-left: 10px;

        img {
            width: 25px;
            height: 25px;
        }
    }

    .button_code {
        display: flex;
        align-items: center;
        justify-content: center;

        .el-button--small, .el-button--small.is-round {
            padding: 11px 15px !important;
        }
    }
</style>